import React from 'react'
import { Helmet } from 'react-helmet-async'
import PayOnlineContent from '../components/pay-online/PayOnlineContent'

export default function PayOnline() {
  return (
    <>
      <Helmet>
        <title>Pay Online - A Plus A Driving School</title>
        <meta name="description" content="Pay for your driving lessons online securely. Multiple payment options available." />
      </Helmet>
      <PayOnlineContent />
    </>
  )
}

